import { useQuery } from '@tanstack/react-query';
import { createHttpClient } from '@shared/adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { GetLocationOrdersParams, ReceiveApiAdapter } from '../adapters/ReceiveApiAdapter';

const httpClient = createHttpClient(apiClientWH);
const receiveAdapter = new ReceiveApiAdapter(httpClient);

export const useLocationOrders = (
    receptionId: number,
    params?: GetLocationOrdersParams,
    enabled: boolean = true
) => {
    return useQuery({
        queryKey: ['location-orders', receptionId, params],
        queryFn: () => receiveAdapter.getLocationOrders(receptionId, params),
        enabled: enabled && !!receptionId,
    });
};

